export const MIN_NUMBER_VALUE = 0;
export const MIN_LOAN_NUMBER_VALUE = 1000000;
export const MIN_LOAN_VIEW_VALUE = '1,000,000';
export const MAX_NUMBER_VALUE = 100;
export const MIN_CATEGORY_VALUE = 0;
export const MAX_CATEGORY_VALUE = 5;
export const GEO_LATITUDE_RANGE = 90;
export const GEO_LONGITUDE_RANGE = 180;
